angular.module('clients')
    .component('clientStatusLabel', {
        bindings: {
            status: '<'
        },
        template: `
            <span class="label label-default client-status-label-{{$ctrl.status}}">{{ 'client.status.'.concat($ctrl.status) | translate }}</span>
        `
    })
